import { render, staticRenderFns } from "./module_titlle.vue?vue&type=template&id=c456a6b4&scoped=true"
import script from "./module_titlle.vue?vue&type=script&lang=js"
export * from "./module_titlle.vue?vue&type=script&lang=js"
import style0 from "./module_titlle.vue?vue&type=style&index=0&id=c456a6b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c456a6b4",
  null
  
)

export default component.exports